var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("span", { staticClass: "mr-3 flex items-center text-sm mb-1" }, [
    _c(
      "span",
      { staticClass: "slot__container text-primary-500 mr-1 h-5 w-24" },
      [
        _c(
          "p",
          {
            staticClass:
              "flex font-400 customlineH min-w-24 text-22 text-storm-gray truncate max-w-36",
          },
          [_vm._v(" " + _vm._s(_vm.title) + " ")]
        ),
      ]
    ),
    _c(
      "span",
      {
        staticClass: "font-normal text-sm text-primary-black customlineH",
        class: _vm.contentStyles,
        style: {
          cursor: _vm.isEmailValid(_vm.contentData) ? "pointer" : "auto",
          color: _vm.isLink(_vm.contentData) ? "#0076D1" : "primary-black",
        },
        on: { click: _vm.handleClick },
      },
      [
        _vm.isPhoneNumber(_vm.contentData)
          ? _c("a", { attrs: { href: "tel:" + _vm.contentData } }, [
              _vm._v("+" + _vm._s(_vm.contentData)),
            ])
          : _c("span", [_vm._v(_vm._s(_vm.contentData))]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }